export const selectAllEvents = (state) => state.incidentDetection.eventData;

export const selectTotalEventsCount = (state) =>
  state.incidentDetection.eventData?.length || 0;

export const selectAllEventSources = (state) => [
  ...new Set(
    state.incidentDetection.eventData.reduce(
      (sources, event) => sources.concat(event.source),
      []
    )
  )
];

export const selectEventsLoading = (state) => state.incidentDetection.loading;
